import React, { Fragment } from 'react';
import { CircularProgress, makeStyles, Backdrop } from '@material-ui/core';

const useStyle = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const Spinner = ({ show = false }) => {
  const classes = useStyle();

  const prevent = event => {
    event.preventDefault();
  };

  return (
    <Fragment>
      <Backdrop
        className={classes.backdrop}
        open={show}
        onClick={event => {
          prevent(event);
        }}>
        <CircularProgress />
      </Backdrop>
    </Fragment>
  );
};

export default Spinner;
